import styled from 'styled-components'

export default styled.button`
  background: #f04;
  border-radius: 3px;
  border: none;
  color: #fff;
  cursor: pointer;
  display: block;
  font-size: 16px;
  font-weight: 700;
  padding: 9px 13px;
  text-align: center;
  margin: 20px auto;
  text-decoration: none;
`



// WEBPACK FOOTER //
// ./src/Button.js